module.exports = __webpack_public_path__ + "static/media/conversation.c679c0fc.png";